<template>
  <div class="express">
    <fixed-header title="物流信息"></fixed-header>
    <div class="express__main scroll-touch">
      <div v-if="nowData.orderGoods" class="express__goods">
        <div
            v-for="(item, index) in nowData.orderGoods"
            :key="index"
            class="express__goods-sku"
        >
          <div class="express__goods-skuimg">
            <img :src="item.originalImg" alt=""/>
          </div>
          <div class="express__goods-skuinfo">
            <section>
              <p>{{ item.goodsName }}</p>
              <!--              <p>￥{{ item.goodsPrice }}</p>-->
            </section>
            <section>
              <p>{{ item.specKeyName }}</p>
              <p>x{{ item.goodsNum }}</p>
            </section>
          </div>
        </div>
      </div>
      <div class="express__delivery">
        <div v-if="!nowData.delivery" class="express__content-null">
          商品即将发货，请耐心等待
        </div>
        <div v-else>
          <section>
            <div>
              <i class="icon car"></i>
            </div>
            <div>
              <p><span>物流公司:</span>{{ nowData.delivery.shippingName }}</p>
              <p><span>物流单号:</span>{{ nowData.delivery.invoiceNo }}</p>
            </div>
          </section>
          <section>
            <div>
              <i class="icon position2"></i>
            </div>
            <div>
              <p class="express__delivery-address">
                <span>收货地址:</span>{{ showAddress(nowData.delivery) }}
              </p>
            </div>
          </section>
        </div>
      </div>
      <div v-if="nowData.delivery" class="express__content">
        <div v-if="!expressData.data||!expressData.data.length" class="express__content-null">
          暂无物流信息
        </div>
        <div v-else>
          <div
              v-for="(item, index) in expressData.data"
              :key="index"
              :style="leftBorder"
              class="express__content-box"
          >
            <div class="express__content-status">
              <section v-if="!index" class="express__content-status--point">
                <i class="icon latest_point"></i>
              </section>
              <section>{{ item.context }}</section>
            </div>
            <div
                :class="[
                'express__content-time',
                index === expressData.data.length - 1 ? 'noborder' : '',
              ]"
            >
              {{ item.time }}
            </div>
          </div>
        </div>
        <!-- <div
          class="express__content-more"
          v-if="expressData.data.length && !showAll"
        >
          <span @click="showAll = true">点击查看更多物流详情 </span>
          <i class="icon open_express"></i>
        </div> -->
      </div>
      <!--      <goods-demo></goods-demo>-->
    </div>
  </div>
</template>

<script>
import FixedHeader from 'components/common/FixedHeader';
// import GoodsDemo from 'components/common/GoodsDemo';
import * as orderApi from 'apis/order';
import { showAddress } from 'utils/order';

export default {
  components: {
    FixedHeader,
    // GoodsDemo
  },
  data() {
    const { orderId, deliveryId } = this.$route.query;
    return {
      orderId,
      deliveryId,
      nowData: {
        delivery: {
          city: {},
          district: {},
          province: {},
          shippingCode: '',
          shippingName: '',
        },
        orderGoods: [],
        express: [],
      },
      expressData: {
        data: [],
      },
      showAll: false,
    };
  },
  created() {
    this.fetchDetail();
  },
  computed: {
    leftBorder() {
      return this.showAll ? '' : 'border:none';
    },
  },
  methods: {
    showAddress,
    showItem(index) {
      if (!this.showAll) {
        return index === 0;
      }
      return true;
    },
    async fetchDetail() {
      const { orderId, deliveryId } = this;
      if (!orderId) {
        return;
      }
      try {
        const data = await orderApi.getExpressDetail({ orderId, deliveryId });
        this.nowData = data;
        if (data && data.express) {
          this.expressData = data.express;
        }
      } catch (error) {
        this.$toast('获取物流信息失败');
      }
    },
  },
};
</script>

<style lang="scss">
.express {
  height: 100%;
  box-sizing: border-box;

  &__main {
    height: 100%;
  }

  &__goods {
    padding: 30px 35px;
    background: #fff;
    border-radius: 20px;
    margin: 30px 30px 20px 30px;

    &-sku {
      display: flex;
      border-bottom: 2px solid rgba(211, 211, 211, 0.5);
      padding: 20px 0;

      &:last-of-type {
        border: none;
      }
    }

    &-skuimg {
      width: 150px;
      height: 150px;
      margin-right: 28px;

      img {
        height: 100%;
        max-width: 100%;
      }
    }

    &-skuinfo {
      font-size: 22px;
      flex: 1;

      section {
        display: flex;
        font-size: 26px;
        color: #000000;
        margin-bottom: 10px;

        p:first-child {
          word-break: break-all;
          width: 335px;
          margin-right: 28px;
        }

        p:last-child {
          flex: 1;
        }
      }

      section:nth-of-type(2) {
        font-size: 24px;
        color: #999999;
      }

      section:nth-of-type(3) {
        display: flex;
        justify-content: flex-end;
      }
    }
  }

  &__delivery {
    padding: 30px 35px;
    background: #fff;
    border-radius: 20px;
    margin: 30px 30px 20px 30px;

    &-address {
      line-height: 1.3 !important;
    }

    section {
      display: flex;
      align-items: center;
      font-size: 24px;
      color: #000000;

      &:first-child {
        margin-bottom: 22px;

        p:first-child {
          margin-bottom: 12px;
        }
      }

      div:first-child {
        width: 43px;
        margin-right: 50px;
        text-align: center;
      }

      div:last-child {
        flex: 1;

        p {
          line-height: 1;
          word-break: break-all;
        }

        span {
          color: #9b9b9b;
          margin-right: 16px;
        }
      }
    }
  }

  &__content {
    padding: 45px 35px 20px 35px;
    background: #fff;
    border-radius: 20px;
    margin: 0 30px 30px 30px;

    &-more {
      position: relative;
      z-index: 100;
      color: #9b9b9b;
      font-size: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: -40px;

      span {
        margin-right: 10px;
      }
    }

    &-box {
      border-left: 2px solid #cbcbcb;
      position: relative;
      padding: 0 25px;
      margin-top: -16px;
    }

    &-box::after {
      content: "";
      display: inline-block;
      position: absolute;
      left: -12px;
      top: -4px;
      width: 13px;
      height: 13px;
      border-radius: 50%;
      border: 6px solid #fff;
      background: #9b9b9b;
    }

    &-box:first-child::after {
      display: none !important;
    }

    &-box:last-child {
      border: none;
      top: 2px;
      left: 2px;
    }

    &-null {
      font-size: 32px;
      text-align: center;
      color: #ccc;
    }

    &-status {
      display: flex;
      font-size: 22px;
      color: #000000;

      &--point {
        position: absolute;
        left: -12px;
        top: 3px;
        background: #fff;
        z-index: 10000;
      }

      section {
        margin-top: -4px;
        word-break: break-all;
        line-height: 1.4;
      }
    }

    &-time {
      height: 73px;
      margin: 20px 0;
      font-size: 22px;
      color: #9b9b9b;
    }
  }

  .noborder {
    border: none;
  }
}
</style>

